// extracted by mini-css-extract-plugin
module.exports = {"logoutPopup":"LogoutPopup_logoutPopup__-6C3M","mobileLogoutPopup":"LogoutPopup_mobileLogoutPopup__2BhPt","logoutIcon":"LogoutPopup_logoutIcon__3VEAI"};